module.exports = __webpack_public_path__ + "static/media/Genetic-Banner-Opacity.46102454.png";